import { render } from "./RecruitmentTab3.vue?vue&type=template&id=66c047e7&scoped=true"
import script from "./RecruitmentTab3.vue?vue&type=script&lang=js"
export * from "./RecruitmentTab3.vue?vue&type=script&lang=js"

import "./RecruitmentTab3.vue?vue&type=style&index=0&id=66c047e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c047e7"]])

export default __exports__